import { mapKeys, camelCase } from 'lodash';
import history from '../components/Extensions/History';

export const conditionalBackHandler = (event, condition) => {
  event.preventDefault();
  if (condition) {
    history.goBack();
  } else {
    history.push('results');
  }
};

export const convertPropertiesToCamelCase = (object) => {
  return (
    mapKeys(object, (v, k) => {
      return camelCase(k);
    })
  );
};

export const nopEvent = {
  preventDefault: () => {},
  stopPropagation: () => {},
};

export const createEventTarget = (value) => {
  return (
    {
      target: {
        value,
      },
    }
  );
};
